module.exports = __webpack_public_path__ + "static/media/13.0e483730.jpg";